import { render, staticRenderFns } from "./GridItem.vue?vue&type=template&id=1c3d0eae"
import script from "./GridItem.vue?vue&type=script&lang=js"
export * from "./GridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports